// bm-article.js — Journal article contents list.
// Gives every <h2> in the article body an id (if missing) and lists them in [data-bm-toc].
// The list is only shown at ≥990px (CSS); without JS it stays hidden.
(() => {
  const body = document.querySelector('[data-bm-article-body]');
  const toc = document.querySelector('[data-bm-toc]');
  const list = document.querySelector('[data-bm-toc-list]');
  if (!body || !toc || !list) return;

  const headings = Array.from(body.querySelectorAll('h2')).filter((h) => h.textContent.trim());
  if (headings.length < 2) return;

  const used = new Set();
  const slug = (text) => {
    const base = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
    let id = base;
    for (let i = 2; used.has(id) || document.getElementById(id); i++) id = `${base}-${i}`;
    used.add(id);
    return id;
  };

  const links = headings.map((h) => {
    if (!h.id) h.id = slug(h.textContent.trim());
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${h.id}`;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
    return a;
  });
  toc.hidden = false;

  // Mark the section currently being read.
  if (!('IntersectionObserver' in window)) return;
  const visible = new Map();
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => visible.set(e.target, e.isIntersecting));
      let current = headings.findIndex((h) => visible.get(h));
      if (current === -1) {
        current = headings.reduce((acc, h, i) => (h.getBoundingClientRect().top < 160 ? i : acc), 0);
      }
      links.forEach((a, i) => a.setAttribute('aria-current', i === current ? 'true' : 'false'));
    },
    { rootMargin: '-120px 0px -60% 0px' }
  );
  headings.forEach((h) => observer.observe(h));
})();
